/**
 * 我销售的竞价列表页面地址
 */
export const TRADITION_AUCTION_SALE_LIST_PAGE_PATH =
  '/auction/tradition/list/sale'
